import { Link } from 'react-router-dom'

/** A miss on a slug that has no page. Kept explicit rather than redirecting, so a
 *  bad inbound link reports honestly instead of silently landing on the index. */
export function NotFound({
  title,
  detail,
  backTo,
  backLabel,
}: {
  title: string
  detail: string
  backTo: string
  backLabel: string
}) {
  return (
    <div className="mx-auto max-w-2xl px-5 py-24 text-center">
      <h1 className="text-2xl font-display text-foreground mb-3">{title}</h1>
      <p className="text-muted-foreground mb-6">{detail}</p>
      <Link to={backTo} className="underline decoration-border underline-offset-4 hover:decoration-foreground">
        {backLabel}
      </Link>
    </div>
  )
}
